$(function () {
	$.nette.init();
});

function isActiveSubmitElement(e) {
	var activeSubmitElement = e.originalEvent.explicitOriginalTarget;	// pro Firefox
	if (!activeSubmitElement) {
		activeSubmitElement = e.target.activeElement;	// pro Chrome a ostatní
	}

	return $(activeSubmitElement).is(':submit')
		&&
		$(activeSubmitElement).closest('.form--changed').length;
}

function formSetIsChanged($form) {
	if (!$form.length) return;

	$form.addClass('form--changed');
	window.beforeunload_enable = true;
}

window.beforeunload_enable = false;

$(window).on('beforeunload', function(e) {
	if (isActiveSubmitElement(e)) {
		// pokud klikám na submit ze změněného formuláře, tak ho chci odeslat a změny tedy neztrácím
		return undefined;	// hlášku nezobrazovat
	}

	if (window.beforeunload_enable) {
		// Již se nedají nastavovat vlastní hlášky
		// https://stackoverflow.com/questions/1119289/how-to-show-the-are-you-sure-you-want-to-navigate-away-from-this-page-when-ch
		return true;
	}

	// hlášku nezobrazovat
	return undefined;
});

$(function() {
	$('input[type="submit"]').click(function() {
		window.beforeunload_enable = false;
	});

	if ($('form.form--changed').length) {
		window.beforeunload_enable = true;
	}

});


// CVE-2026-109619 (https://trello.com/c/5EA1WD6I/89-update-php-critical): nginx blokuje multipart.
// nette.ajax.js posílá POST formuláře jako FormData, proto je bez souborů převedeme na urlencoded.
// Dočasné, nahradí frontend datagridu 7.
$.nette.ext('noMultipart', {
	prepare: function(settings) {
		if (
			window.FormData
			&& settings.data instanceof FormData
			&& !(settings.nette && settings.nette.form && settings.nette.form.find('input[type=file]').length)
		) {
			settings.data = new URLSearchParams(settings.data).toString();
			settings.processData = false;
			settings.contentType = 'application/x-www-form-urlencoded; charset=UTF-8';
		}
	}
});

$.nette.ext('live').after(function($el) {

	// Kvůli nabindování ajaxu na dynamicky přidaná tlačítka
	$.nette.load();

	var $select = $el.find(':input');

	$select.on('change', function(){
		var $form = $(this).closest('form');

		if (
			$form.closest('.datagrid').length
			||
			$form.hasClass('noBeforeUnloadMessage')
			||
			$(this).hasClass('noBeforeUnloadMessage')
		) {
			return;
		}

		formSetIsChanged($form);
	});
});
